if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        const previewImage = opener.closest('modal-opener')?.querySelector('.product__media img');
        const previewWidth = previewImage?.getBoundingClientRect().width;

        if (previewWidth) {
          // Enlarge by one third, while keeping the image within the viewport.
          this.querySelectorAll('.product-media-modal__content > img').forEach((image) => {
            image.style.width = 'auto';
            image.style.height = 'auto';
            image.style.maxWidth = `min(100%, ${previewWidth * (4 / 3)}px)`;
            image.style.maxHeight = 'calc(100dvh - 8rem)';
          });
        }

        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
